/* eslint-disable no-unused-vars */
import { makeAutoObservable } from "mobx";
import ApplicationApi from "../api/ApplicationApi";

class ApplicationStore {
    isLoading: boolean = true;
    IsAuthorized: boolean = true;
    loadError: boolean = false;
    Properties: { value: number; label: string }[] = [];
    applicationApi: ApplicationApi;
    constructor(applicationApi: ApplicationApi) {
        makeAutoObservable(this);
        this.applicationApi = applicationApi
    }

    LoadPropertyListAsync = async () => {
        this.applicationApi.getPropertyListAsync().then((res)=>{
            this.Properties = res.data.properties.map((i) => ({ value: i.id, label: `${i.name} (${i.id})` }));
            this.isLoading = false;
            this.loadError = false;
        }).catch((err) => {
            this.isLoading = false;
            const status = err?.response?.status;
            if (status === 401 || status === 403) {
                this.IsAuthorized = false;
            } else {
                this.loadError = true;
            }
        })
    }
}
export default ApplicationStore